import * as React from 'react'
import { makeDefaultTooltipId } from '../../../../../utilities/helpers'
import { TooltipWithIcon } from '../../../../../components/TooltipWithIcon'
import { Input } from 'antd-v4'

interface Props {
  rows: number
  tooltipIconClassName?: string
  value: string
  label?: string | null
  tooltipContent?: string | JSX.Element | JSX.Element[]
  tooltipProps?: any
  disabled: boolean
  onChange: (value: string) => void
}

export const Description = (props: Props) => {
  const {
    rows,
    tooltipIconClassName,
    value,
    label,
    tooltipContent,
    tooltipProps,
    onChange,
    disabled,
  } = props
  const tooltipId = label && makeDefaultTooltipId(label)

  return (
    <div className='form-group'>
      {label && (
        <label className='mb-2'>
          {label}
          {tooltipContent && (
            <TooltipWithIcon
              tooltipIconClassName={tooltipIconClassName}
              tooltipId={tooltipId}
              tooltipContent={tooltipContent}
              tooltipProps={tooltipProps}
            />
          )}
        </label>
      )}
      <Input.TextArea
        className='form-control'
        rows={rows}
        value={value}
        disabled={disabled}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
      />
    </div>
  )
}
